import React, {
    useEffect,
    useContext,
    useState,
    useReducer,
    useCallback,
} from "react";
import { useLocation, useHistory } from "react-router-dom";
import dayjs from "dayjs";

// import ReactHlsPlayer from "react-hls-player";
import ReactPlayer from "react-player";

import Button from "@mui/material/Button";
import { Tooltip, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import ListItemIcon from "@mui/material/ListItemIcon";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import StarIcon from "@mui/icons-material/Star";
import { IconButton } from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import TheatersIcon from "@mui/icons-material/Theaters";
import Checkbox from "@mui/material/Checkbox";
import FilterListIcon from "@mui/icons-material/FilterList";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SpaceBarOutlinedIcon from "@mui/icons-material/SpaceBarOutlined";
import MuiAlert from "@mui/material/Alert";
import { Snackbar } from "@mui/material";

// Bootstrap
import Container from "react-bootstrap/Container";

// My Files
import { DatabaseContext, UserContext } from "../../context";
import firebase from "../../firebase";
import NoPermissionsMessage from "../NoPermissionsMessage";
import {
    jsonFromUserEnteredStringArray,
    makeid,
    shouldFileBeVisible,
    timeString,
    commaSeperatedStringFromArray,
    commaSeperatedStringFromLabels,
} from "../../utility";
import MarkOutDialog from "./MarkOutDialog";
import ToolbarWithLogo from "../ToolbarWithLogo";
import ConfirmDeleteDialog from "../ConfirmDeleteDialog";
import DialogWithTextInput from "../DialogWithTextInput";
import KeyDownHandler from "../KeyDownHandler";
import TimelineFilterDialog from "./TimelineFilterDialog";
import ShareTimelineDialog from "./ShareTimelineDialog";
import CopyTimelineDialog from "./CopyTimelineDialog";
import SavePlaylistDialog from "./SavePlaylistDialog";
import { exportTimelineToXML } from "./timelineXml";
import { deletePlaylistOrTimelineRecord } from "../playlists/playlistTimelineDeletion";

function createData(key, index, inTime, outTime, name, labels, notes, stars) {
    return {
        key: key,
        index: index,
        inTime: inTime,
        outTime: outTime,
        name: name,
        labels: labels,
        notes: notes,
        stars: stars,
        selected: true,
        filteredOutByCode: false,
        filteredOutByRating: false,
        filteredOutByLabels: false,
    };
}

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} variant="filled" ref={ref} {...props} />;
});

export default function SimpleVideoAnalysisPage(props) {
    const history = useHistory();
    const location = useLocation();

    const {
        files,
        filesLoaded,
        groups,
        groupsLoaded,
        timelineUsage,
        timelineUsageLoaded,
    } = useContext(DatabaseContext);

    const [timeline, setTimeline] = useState();

    const [file, setFile] = useState();
    const playerRef = React.useRef();
    // The timeline whose open this mount has already recorded
    const recordedTimelineOpenRef = React.useRef(null);

    const { currentUserData } = useContext(UserContext);
    const [anchorEl, setAnchorEl] = useState(null);

    // const [playing, setPlaying] = useState(false);

    const [userHasPermission, setUserHasPermission] = useState();
    const [userCanUsePlaylists, setUserCanUsePlaylists] = useState(false);

    const [markButtonTitle, setMarkButtonTitle] = useState("Mark In");

    const [markInTime, setMarkInTime] = useState();
    const [markOutTime, setMarkOutTime] = useState();

    const [rows, setRows] = useState([]);

    const [markOutDialogVisible, setMarkOutDialogVisible] = useState(false);

    const [playing, setPlaying] = useState(false);

    const [rowToEdit, setRowToEdit] = useState();

    const [timelineNameDialogOpen, setTimelineNameDialogOpen] = useState(false);
    const [playlistNameDialogOpen, setPlaylistNameDialogOpen] = useState(false);
    const [copyDialogOpen, setCopyDialogOpen] = useState(false);
    const [copyDialogTitle, setCopyDialogTitle] = useState("");
    const [copyDialogMessage, setCopyDialogMessage] = useState("");

    // const [editingTimeline, setEditingTimeline] = useState();

    const [timelineKey, setTimelineKey] = useState("");
    const [timelineName, setTimelineName] = useState("");

    const [confirmDeleteDialogOpen, setConfirmDeleteDialogOpen] =
        useState(false);

    const [shareDialogOpen, setShareDialogOpen] = useState(false);

    const [currentClip, setCurrentClip] = useState(); // Used when previewing clips

    const [showDetailsColumn, setShowDetailsColumn] = useState(false);

    const [sortDirection, setSortDirection] = useState("Ascending");

    const [filterDialogVisible, setFilterDialogVisible] = useState(false);

    const [, forceUpdate] = useReducer((x) => x + 1, 0);

    const [statusType, setStatusType] = useState("error");
    const [statusMessage, setStatusMessage] = useState("");
    const [statusIsVisible, setStatusIsVisible] = useState(false);

    const [isOwner, setIsOwner] = useState(false);

    const [ratings, setRatings] = useState([]); // Just use this to preserve whether groups are selected in the filter
    const [groupsAfterFiltering, setGroupsAfterFiltering] = useState([]); // Just use this to preserve whether groups are selected in the filter

    const handleTimelineSnapshot = useCallback((snapshot) => {
        let key = snapshot.key;
        let data = snapshot.val();

        if (data) {
            let instances = [];

            if (data.instances) {
                // Turn messages from a JSON object to an array

                let clipKeys = Object.keys(data.instances);
                let clipValues = Object.values(data.instances);

                for (let i = 0; i < clipKeys.length; i++) {
                    // Labels
                    let instanceLabels = [];
                    if (clipValues[i].labels) {
                        // Change to Object.values!
                        let labelTextValues = Object.values(
                            clipValues[i].labels
                        );

                        for (
                            let i = 0;
                            i < labelTextValues.length;
                            i++
                        ) {
                            instanceLabels.push(labelTextValues[i]);
                        }
                    }

                    // Notes
                    let instanceNotes = [];
                    if (clipValues[i].notes) {
                        let noteTextValues = Object.values(
                            clipValues[i].notes
                        );

                        for (
                            let i = 0;
                            i < noteTextValues.length;
                            i++
                        ) {
                            instanceNotes.push(noteTextValues[i]);
                        }
                    }

                    instances.push({
                        key: clipKeys[i],
                        index: clipValues[i].index,
                        name: clipValues[i].name,
                        labels: instanceLabels,
                        notes: instanceNotes,
                        note: clipValues[i].note,
                        stars: clipValues[i].stars,
                        inTime: clipValues[i].inTime,
                        outTime: clipValues[i].outTime,
                    });
                }
            }

            // Groups
            let timelineGroups = [];
            if (data.groups) {
                let groupKeys = Object.keys(data.groups);

                for (let i = 0; i < groupKeys.length; i++) {
                    timelineGroups.push(groupKeys[i]);
                }
            }

            // Users
            let timelineUsers = [];
            if (data.users) {
                let userKeys = Object.keys(data.users);

                for (let i = 0; i < userKeys.length; i++) {
                    timelineUsers.push(userKeys[i]);
                }
            }

            setTimeline({
                key: key,
                instances: instances,
                name: data.name,
                owner: data.owner,
                lastOpened: data.lastOpened,
                created: data.created,
                video: data.video,
                users: timelineUsers,
                groups: timelineGroups,
            });
        } else {
            console.log("No Timeline Data");
        }
    }, []);

    useEffect(() => {
        const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
            // detaching the listener
            if (!user) {
                // If no user is logged in, redirect to sign in page
                // history.replace("/signin");
                history.replace("/signin?url=" + location.pathname);
            }
        });

        if (
            currentUserData &&
            filesLoaded &&
            groupsLoaded
        ) {
            const urlParams = new URLSearchParams(location.search);
            const video = urlParams.get("video");

            let matchingFile = files.find((f) => f.key === video);

            //
            if (currentUserData.permissions.createOwnPlaylist === true) {
                setUserCanUsePlaylists(true);
            } else {
                setUserCanUsePlaylists(false);
            }

            //
            if (
                matchingFile &&
                shouldFileBeVisible(matchingFile, groups, currentUserData)
            ) {
                setUserHasPermission(true);
                setFile(matchingFile);
                var shouldShowDetailsColumn = false;

                if (timeline && timelineKey !== timeline.key) {
                    setTimelineKey(timeline.key);
                    setTimelineName(timeline.name);

                    if (timeline.owner === currentUserData.key) {
                        setIsOwner(true);
                    } else {
                        setIsOwner(false);
                    }

                    let rowsArray = [];
                    timeline.instances
                        .sort((a, b) => {
                            if (a.index > b.index) return 1;
                            if (a.index < b.index) return -1;
                            return 0;
                        })
                        .forEach((instance) => {
                            if (instance.labels.length > 0) {
                                shouldShowDetailsColumn = true;
                            }

                            instance.labels.forEach((label) => {
                                label.filteredOutByLabel = false;
                            });

                            rowsArray.push(
                                createData(
                                    instance.key,
                                    instance.index,
                                    instance.inTime,
                                    instance.outTime,
                                    instance.name,
                                    instance.labels,
                                    instance.notes,
                                    instance.stars
                                )
                            );
                        });

                    setShowDetailsColumn(shouldShowDetailsColumn);
                    setRows(rowsArray);
                    setRatings([
                        { stars: 0, selected: true },
                        { stars: 1, selected: true },
                        { stars: 2, selected: true },
                        { stars: 3, selected: true },
                    ]);

                    // Update most recent opened date for the timeline
                    let timelinesRef = firebase.database().ref("timelines");
                    console.log("Updating Timeline Last Opened");
                    timelinesRef
                        .child(timeline.key)
                        .update({ lastOpened: dayjs().toString() });

                    let timelineInfoRef = firebase
                        .database()
                        .ref("timelineinfo");

                    timelineInfoRef
                        .child(timeline.key)
                        .update({ lastOpened: dayjs().toString() });
                }
            } else {
                setUserHasPermission(false);
            }
        }

        return () => unsubscribe();
    }, [
        currentUserData,
        files,
        filesLoaded,
        groups,
        groupsLoaded,
        history,
        location.pathname,
        location.search,
        timeline,
        timelineKey,
    ]);

    /**
     * Record that THIS user opened this timeline.
     *
     * timelines/<key>/lastOpened and timelineinfo/<key>/lastOpened are written
     * above, but they are a single value shared by everyone with access, so
     * they cannot answer "when did this user last open this" — which is what
     * the Recently opened folder asks. timelineusage answers it per person,
     * the way playlistusage does for playlists.
     *
     * This is its own effect rather than a few more lines in the one above,
     * because that one is gated on timelineKey !== timeline.key and so runs
     * exactly once per timeline. If timelineusage had not loaded by then the
     * open would never be recorded. Here the effect re-runs as the snapshot
     * arrives, and the ref keeps it to one write per timeline.
     */
    useEffect(() => {
        if (
            userHasPermission !== true ||
            !currentUserData ||
            !timeline ||
            !timelineUsageLoaded ||
            recordedTimelineOpenRef.current === timeline.key
        ) {
            return;
        }

        recordedTimelineOpenRef.current = timeline.key;

        const timelineUsageRef = firebase.database().ref("timelineusage");
        const usageObject = timelineUsage.find(
            (usage) =>
                usage.user === currentUserData.key &&
                usage.timeline === timeline.key,
        );

        if (usageObject) {
            timelineUsageRef
                .child(usageObject.key)
                .update({ lastOpened: dayjs().toString() });
        } else {
            timelineUsageRef.push({
                timeline: timeline.key,
                user: currentUserData.key,
                lastOpened: dayjs().toString(),
            });
        }
    }, [
        currentUserData,
        timeline,
        timelineUsage,
        timelineUsageLoaded,
        userHasPermission,
    ]);

    useEffect(() => {
        if (userHasPermission !== true) {
            return;
        }

        const requestedTimelineKey = new URLSearchParams(location.search).get(
            "key"
        );

        if (!requestedTimelineKey) {
            return;
        }

        console.log("Reading Timeline from Firebase");
        const timelineRef = firebase
            .database()
            .ref("timelines")
            .child(requestedTimelineKey);
        const snapshotHandler = timelineRef.on(
            "value",
            handleTimelineSnapshot,
            (error) =>
                console.error("Unable to get timeline from Firebase", error)
        );

        return () => timelineRef.off("value", snapshotHandler);
    }, [handleTimelineSnapshot, location.search, userHasPermission]);

    // Called from KeyDownHandler component
    function keyWasPressed(e) {
        if (
            markOutDialogVisible ||
            playlistNameDialogOpen ||
            timelineNameDialogOpen ||
            confirmDeleteDialogOpen ||
            shareDialogOpen ||
            e.target.nodeName === "VIDEO"
        ) {
            return;
        }

        if (e.code === "Space") {
            e.preventDefault();

            if (playing === true) {
                handlePause();
            } else {
                handlePlay();
            }
        }
    }

    function handleMarkButtonPress() {
        if (!isOwner) {
            setCopyDialogTitle("Cannot edit shared timeline");
            setCopyDialogMessage(
                "Create your own copy of this timeline, which you can then edit?"
            );
            setCopyDialogOpen(true);

            return;
        }

        if (markButtonTitle === "Mark In") {
            // Opening an instance

            setMarkButtonTitle("Mark Out");
            setMarkInTime(playerRef.current.getCurrentTime());
        } else {
            // Closing An Instance

            setMarkOutTime(playerRef.current.getCurrentTime());
            setPlaying(false);

            setMarkOutDialogVisible(true);
        }
    }

    function handleAddNewRow(name, notes, stars) {
        if (name) {
            let timelinesRef = firebase.database().ref("timelines");

            let newInstanceKey = makeid(19);

            // Add instance to firebase
            timelinesRef
                .child(timelineKey)
                .child("instances")
                .child(newInstanceKey)
                .set({
                    index: rows.length,
                    inTime: markInTime,
                    outTime: markOutTime,
                    name: name,
                    notes: jsonFromUserEnteredStringArray(notes),
                    stars: stars,
                });

            // Add instance to local rows array
            setRows([
                ...rows,
                createData(
                    newInstanceKey,
                    rows.length,
                    markInTime,
                    markOutTime,
                    name,
                    [],
                    notes,
                    stars
                ),
            ]);
        }

        setPlaying(true);
        handleCloseMarkOutDialog();
    }

    function handleDeleteRow(row) {
        let timelinesRef = firebase.database().ref("timelines");

        setRows(rows.filter((r) => r.key !== row.key));

        timelinesRef
            .child(timelineKey)
            .child("instances")
            .child(row.key)
            .remove();

        handleCloseMarkOutDialog();
    }

    function handleEditRow(row) {
        // Edit the row in firebase (the local version has already been edited in MarkOutDialog component)

        let timelinesRef = firebase.database().ref("timelines");

        timelinesRef
            .child(timelineKey)
            .child("instances")
            .child(row.key)
            .update({
                inTime: row.inTime,
                outTime: row.outTime,
                name: row.name,
                notes: jsonFromUserEnteredStringArray(row.notes),
                stars: row.stars,
            });

        handleCloseMarkOutDialog();
    }

    function handlePlay() {
        setPlaying(true);
    }

    function handlePause() {
        setPlaying(false);
    }

    const handleRowSelect = (row) => () => {
        if (!isOwner) {
            setCopyDialogTitle("Cannot edit shared timeline");
            setCopyDialogMessage(
                "Create your own copy of this timeline, which you can then edit?"
            );
            setCopyDialogOpen(true);

            return;
        }

        setPlaying(false);
        setRowToEdit(row);
        setMarkOutDialogVisible(true);
    };

    const handlePreviewRowPressed = (row) => (event) => {
        // The play button sits inside a clickable table cell, so prevent the
        // click from launching the same preview twice as it bubbles.
        event.stopPropagation();
        setCurrentClip(row);
        playerRef.current.seekTo(row.inTime);
        setPlaying(true);
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
    };

    async function handleCloseDeleteDialog(result) {
        if (result === true && currentUserData) {
            try {
                await deletePlaylistOrTimelineRecord("timeline", timelineKey);
                history.goBack();
            } catch (error) {
                console.error("Unable to delete timeline", error);
                setStatusMessage("Unable to delete timeline");
                setStatusType("error");
                setStatusIsVisible(true);
            }
        }

        setConfirmDeleteDialogOpen(false);
    }

    function handleDeleteTimelineButtonPress() {
        handleMenuClose();
        setConfirmDeleteDialogOpen(true);
    }

    async function handleCreatePlaylistButtonPress() {
        handleMenuClose();

        setPlaylistNameDialogOpen(true);
        setPlaying(false);
    }

    function handleRenameTimelineButtonPress() {
        handleMenuClose();

        if (!isOwner) {
            setCopyDialogTitle("Cannot rename shared timeline");
            setCopyDialogMessage(
                "Create your own copy of this timeline, which you can then edit?"
            );
            setCopyDialogOpen(true);

            return;
        }

        setTimelineNameDialogOpen(true);
    }

    function handleCloseTimelineNameDialog(newName, okPressed) {
        if (newName !== "" && okPressed) {
            // Rename the timeline in firebase
            let timelinesRef = firebase.database().ref("timelines");

            timelinesRef.child(timelineKey).update({ name: newName });

            let timelineInfoRef = firebase.database().ref("timelineinfo");

            timelineInfoRef.child(timelineKey).update({ name: newName });

            // Rename locally

            setTimelineName(newName);
        }
        setTimelineNameDialogOpen(false);
    }

    function savePlaylist(newRows, name, includeNotes) {
        if (newRows && name) {
            // Add a record to file Usage
            let ref = firebase.database().ref("fileusage");

            ref.push({
                file: file.key,
                fileName: file.displayName,
                fileType: file.type,
                user: currentUserData.key,
                action: "PlaylistCreate",
                date: dayjs().toString(),
            });

            // Create the playlist
            let playlistsRef = firebase.database().ref("playlists");

            // /inTime, outTime, name, note, stars

            let clips = {};
            let clipsArray = [];

            var index = 0;
            newRows.forEach((row) => {
                if (row.selected && shouldShowInTable(row)) {
                    var note = "";

                    if (includeNotes) {
                        note = commaSeperatedStringFromArray(row.notes);
                    }

                    let clipObject = {
                        index: index,
                        inTime: row.inTime,
                        outTime: row.outTime,
                        name: row.name,
                        note: note,
                        labels: jsonFromUserEnteredStringArray(row.labels),
                        stars: row.stars,
                        video: file.key,
                    };

                    index++;
                    clips[row.key] = clipObject;
                    clipsArray.push(clipObject);
                }
            });

            let key = makeid(19);

            let firebasePlaylistObject = {
                key: key,
                name: name,
                owner: currentUserData.key,
                video: file.key,
                clips: clips,
                created: dayjs().toString(),
            };

            playlistsRef.child(key).set(firebasePlaylistObject);

            let playlistInfoRef = firebase.database().ref("playlistinfo");

            playlistInfoRef.child(key).set({
                key: key,
                name: name,
                owner: currentUserData.key,
                video: file.key,
                created: dayjs().toString(),
            });

            history.replace("/playlist?key=" + key);
        }
    }

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    function handleProgress(progress) {
        if (currentClip) {
            if (progress.playedSeconds > currentClip.outTime) {
                setPlaying(false);
                setCurrentClip(null);
            }
        }
    }

    function handleCloseMarkOutDialog() {
        setRowToEdit(null);
        setMarkButtonTitle("Mark In");
        setMarkInTime();
        setMarkOutDialogVisible(false);
    }

    const handleSelectRowCheckboxChange = (row) => () => {
        row.selected = !row.selected;

        setRows([...rows]);
    };

    function handleExportTimelineButtonPress() {
        exportTimelineToXML(timeline.instances, timeline.name);
        setAnchorEl(null);
    }

    function handleClosePlaylistNameDialog(name, okPressed, includeNotes) {
        if (name !== "" && okPressed) {
            savePlaylist(rows, name, includeNotes);
        }

        setPlaylistNameDialogOpen(false);
    }

    const handleChooseXMLClick = (e) => {
        handleMenuClose();

        if (!isOwner) {
            setCopyDialogTitle("Cannot edit shared timeline");
            setCopyDialogMessage(
                "Create your own copy of this timeline, which you can then edit?"
            );
            setCopyDialogOpen(true);
            return;
        }

        const files = e.target.files;

        if (FileReader && files && files.length) {
            var fr = new FileReader();

            var convert = require("xml-js");

            fr.onload = function () {
                let filesArray = [...files];

                for (let i = 0; i < files.length; i++) {
                    files[i].key = makeid(25);
                }

                if (filesArray.length === 1) {
                    var reader = new FileReader();
                    reader.readAsText(filesArray[0]);
                    reader.onloadend = function () {
                        var xmlData = reader.result;

                        var xmlJSON = convert.xml2json(xmlData, {
                            compact: true,
                            spaces: 4,
                        });

                        var xmlObject = JSON.parse(xmlJSON);

                        var instances = xmlObject.file.ALL_INSTANCES.instance;

                        var rowsToAdd = [];
                        instances.forEach((instance) => {
                            var code = instance.code._text;
                            var start = parseFloat(instance.start._text);
                            var end = parseFloat(instance.end._text);

                            var labelsToAdd = [];
                            var labelsFromFile = instance.label;

                            // Labels
                            if (labelsFromFile !== undefined) {
                                if (Array.isArray(labelsFromFile)) {
                                    // If there are multiple labels, then it's an array
                                    labelsFromFile.forEach((label) => {
                                        var labelObject = {};
                                        labelObject.text = label.text._text;
                                        labelObject.filteredOutByLabel = false;

                                        if (label.group) {
                                            labelObject.group =
                                                label.group._text;
                                        }
                                        if (label.start) {
                                            labelObject.start =
                                                label.start._text;
                                        }

                                        labelsToAdd.push(labelObject);
                                    });
                                } else {
                                    // If there is one label, it's an object
                                    var labelObject = {};

                                    labelObject.text =
                                        labelsFromFile.text._text;
                                    labelObject.filteredOutByLabel = false;

                                    if (labelsFromFile.group) {
                                        labelObject.group =
                                            labelsFromFile.group._text;
                                    }

                                    if (labelsFromFile.start) {
                                        labelObject.start =
                                            labelsFromFile.start._text;
                                    }

                                    labelsToAdd.push(labelObject);
                                }
                            }
                            // console.log(labelsToAdd);

                            // Notes
                            var notesToAdd = [];
                            var notesFromFile = instance.free_text;

                            if (notesFromFile !== undefined) {
                                if (Array.isArray(notesFromFile)) {
                                    notesFromFile.forEach((note) => {
                                        notesToAdd.push(note._text);
                                    });
                                } else {
                                    notesToAdd.push(notesFromFile._text);
                                }
                            }

                            rowsToAdd.push({
                                code: code,
                                start: start,
                                end: end,
                                labels: labelsToAdd,
                                notes: notesToAdd,
                            });
                        });

                        addRowsFromXML(rowsToAdd);
                    };
                }
            };

            fr.readAsDataURL(files[0]);
        }
    };

    function addRowsFromXML(rowsToAdd) {
        var newRows = rows;

        var index = rows.length;
        var shouldShowDetailsColumn = false;

        rowsToAdd.forEach((row) => {
            let timelinesRef = firebase.database().ref("timelines");

            let newInstanceKey = makeid(19);

            // Add instance to firebase
            timelinesRef
                .child(timelineKey)
                .child("instances")
                .child(newInstanceKey)
                .set({
                    index: index,
                    inTime: row.start,
                    outTime: row.end,
                    name: row.code,
                    labels: jsonFromUserEnteredStringArray(row.labels),
                    notes: jsonFromUserEnteredStringArray(row.notes),
                    stars: 0,
                });

            // Add instance to local rows array
            newRows = [
                ...newRows,
                createData(
                    newInstanceKey,
                    index,
                    row.start,
                    row.end,
                    row.code,
                    row.labels,
                    row.notes,
                    0
                ),
            ];

            if (row.labels.length > 0) {
                shouldShowDetailsColumn = true;
            }

            index += 1;
        });

        setShowDetailsColumn(shouldShowDetailsColumn);
        setRows(newRows);
    }

    function handleTimeColumnClick() {
        if (sortDirection === "Ascending") {
            setRows(rows.sort((a, b) => (a.inTime > b.inTime ? 1 : -1)));
            setSortDirection("Descending");
        } else {
            setRows(rows.sort((a, b) => (a.inTime < b.inTime ? 1 : -1)));
            setSortDirection("Ascending");
        }
    }

    function handleNameColumnClick() {
        if (sortDirection === "Ascending") {
            setRows(
                rows.sort((a, b) =>
                    a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
                )
            );
            setSortDirection("Descending");
        } else {
            setRows(
                rows.sort((a, b) =>
                    a.name.toLowerCase() < b.name.toLowerCase() ? 1 : -1
                )
            );
            setSortDirection("Ascending");
        }
    }

    function handleDetailsColumnClick() {
        if (sortDirection === "Ascending") {
            setRows(
                rows.sort((a, b) =>
                    commaSeperatedStringFromArray(a.labels) >
                    commaSeperatedStringFromArray(b.labels)
                        ? 1
                        : -1
                )
            );
            setSortDirection("Descending");
        } else {
            setRows(
                rows.sort((a, b) =>
                    commaSeperatedStringFromArray(a.labels) <
                    commaSeperatedStringFromArray(b.labels)
                        ? 1
                        : -1
                )
            );
            setSortDirection("Ascending");
        }
    }

    function handleNoteColumnClick() {
        if (sortDirection === "Ascending") {
            setRows(
                rows.sort((a, b) =>
                    commaSeperatedStringFromArray(a.notes) >
                    commaSeperatedStringFromArray(b.notes)
                        ? 1
                        : -1
                )
            );
            setSortDirection("Descending");
        } else {
            setRows(
                rows.sort((a, b) =>
                    commaSeperatedStringFromArray(a.notes) <
                    commaSeperatedStringFromArray(b.notes)
                        ? 1
                        : -1
                )
            );
            setSortDirection("Ascending");
        }
    }

    function handleStarsColumnClick() {
        if (sortDirection === "Ascending") {
            setRows(rows.sort((a, b) => (a.stars > b.stars ? 1 : -1)));
            setSortDirection("Descending");
        } else {
            setRows(rows.sort((a, b) => (a.stars < b.stars ? 1 : -1)));
            setSortDirection("Ascending");
        }
    }

    function handleOpenFilterButtonPress() {
        setFilterDialogVisible(true);
    }

    const handleStatusClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setStatusIsVisible(false);
    };

    function handleCloseFilterDialog(
        newFilteredCodes,
        newFilteredLabels,
        newFilteredRatings,
        groups
    ) {
        if (newFilteredCodes) {
            rows.forEach((row) => {
                if (newFilteredCodes.includes(row.name)) {
                    row.filteredOutByCode = false;
                } else {
                    row.filteredOutByCode = true;
                }
            });
        }

        setGroupsAfterFiltering(groups);

        if (newFilteredLabels) {
            rows.forEach((row) => {
                if (row.labels.length === 0) {
                    if (newFilteredLabels.includes("(No Detail)")) {
                        row.filteredOutByLabels = false;
                    } else {
                        row.filteredOutByLabels = true;
                    }
                } else {
                    row.labels.forEach((label) => {
                        if (newFilteredLabels.includes(label.text)) {
                            label.filteredOutByLabel = false;
                        } else {
                            label.filteredOutByLabel = true;
                        }
                    });
                }
            });
        }

        if (newFilteredRatings) {
            rows.forEach((row) => {
                if (newFilteredRatings.includes(row.stars)) {
                    row.filteredOutByRating = false;
                } else {
                    row.filteredOutByRating = true;
                }
            });
        }

        forceUpdate();

        setFilterDialogVisible(false);
    }

    function handleShareButtonPressed() {
        if (!isOwner) {
            setCopyDialogTitle("Cannot share timeline");
            setCopyDialogMessage(
                "Create your own copy of this timeline, which you can then share?"
            );
            setCopyDialogOpen(true);
            return;
        }

        handleMenuClose();

        setShareDialogOpen(true);
    }

    // The dialog reports the outcome itself, in one message that covers both who
    // it was shared with and what was delivered.
    function handleCloseShareDialog() {
        setShareDialogOpen(false);
    }

    function handleCloseCopyDialog(result) {
        if (result === true) {
            console.log("Creating Own Copy of Timeline");
            // Create Own Copy of the timeline for currentUser

            // console.log(timeline.instances);
            let timelinesRef = firebase.database().ref("timelines");

            var instancesJSON = {};

            timeline.instances.forEach((instanceObject) => {
                var instanceJSON = {
                    index: instanceObject.index,
                    inTime: instanceObject.inTime,
                    outTime: instanceObject.outTime,
                    name: instanceObject.name,
                    stars: instanceObject.stars,
                    labels: jsonFromUserEnteredStringArray(
                        instanceObject.labels
                    ),
                    notes: jsonFromUserEnteredStringArray(instanceObject.notes),
                };

                instancesJSON[instanceObject.key] = instanceJSON;
            });

            let newKey = makeid(19);

            timelinesRef.child(newKey).set({
                name: timelineName + " (My Copy)",
                owner: currentUserData.key,
                video: file.key,
                created: dayjs().toString(),
                instances: instancesJSON,
            });

            let timelineInfoRef = firebase.database().ref("timelineinfo");

            timelineInfoRef.child(newKey).set({
                name: timelineName + " (My Copy)",
                owner: currentUserData.key,
                video: file.key,
                created: dayjs().toString(),
            });

            setStatusMessage("Timeline Copied Successfully");
            setStatusType("success");
            setStatusIsVisible(true);
            setRows([]);

            setTimeline(null);
            history.replace(
                "/analysis?video=" + timeline.video + "&key=" + newKey
            );
        }

        setCopyDialogOpen(false);
    }

    function shouldShowInTable(row) {
        // console.log("Show?");
        // console.log(row);

        // return true;

        var filteredOut = false;
        if (row.filteredOutByCode === true) {
            filteredOut = true;
        }

        if (row.labels.length === 0) {
            if (row.filteredOutByLabels === true) {
                filteredOut = true;
            }
        } else {
            if (
                row.labels.filter((label) => label.filteredOutByLabel === false)
                    .length === 0
            ) {
                filteredOut = true;
            }
        }

        if (row.filteredOutByRating === true) {
            filteredOut = true;
        }

        if (filteredOut === true) {
            return false;
        }

        return true;
    }

    const visibleRows = rows.filter(
        (row) => shouldShowInTable(row) === true
    );
    const hiddenClipCount = rows.length - visibleRows.length;

    function renderStars(stars) {
        return (
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    color: "primary.main",
                }}
            >
                {[0, 1, 2].map((starIndex) =>
                    starIndex < stars ? (
                        <StarIcon key={starIndex} sx={{ fontSize: 18 }} />
                    ) : (
                        <StarBorderIcon
                            key={starIndex}
                            sx={{ fontSize: 18 }}
                        />
                    )
                )}
            </Box>
        );
    }

    return (
        <>
            {userHasPermission === undefined && (
                <Box
                    sx={{
                        minHeight: "calc(100vh - 64px)",
                        backgroundColor: "background.default",
                        pt: { xs: 1.5, sm: 2.5 },
                        pb: 10,
                    }}
                >
                    <Container
                        fluid
                        style={{
                            maxWidth: 1800,
                            paddingLeft: 16,
                            paddingRight: 16,
                        }}
                    >
                        <Skeleton
                            variant="rounded"
                            width={82}
                            height={34}
                            sx={{ mb: 1.5, borderRadius: 2 }}
                        />
                        <Box
                            sx={{
                                display: "grid",
                                gridTemplateColumns: "minmax(0, 1fr)",
                                gap: 2,
                            }}
                        >
                            <Skeleton
                                variant="rounded"
                                width="100%"
                                sx={{ pt: "63%", borderRadius: 3 }}
                            />
                            <Skeleton
                                variant="rounded"
                                width="100%"
                                height={360}
                                sx={{ borderRadius: 3 }}
                            />
                        </Box>
                    </Container>
                </Box>
            )}
            {userHasPermission && (
                <Box
                    sx={{
                        minHeight: "calc(100vh - 64px)",
                        backgroundColor: "background.default",
                        pt: { xs: 1.5, sm: 2.5 },
                        pb: 10,
                    }}
                >
                    <Container
                        fluid
                        style={{
                            maxWidth: 1800,
                            paddingLeft: 16,
                            paddingRight: 16,
                        }}
                    >
                        <Box
                            sx={{
                                mb: 1.5,
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                flexWrap: "wrap",
                            }}
                        >
                            <Button
                                color="inherit"
                                startIcon={<ArrowBackIcon />}
                                onClick={() => history.goBack()}
                                sx={{
                                    mr: "auto",
                                    color: "text.secondary",
                                }}
                            >
                                Back
                            </Button>
                            <Button
                                variant="contained"
                                size="small"
                                onClick={handleMarkButtonPress}
                                sx={{
                                    minWidth: 112,
                                    minHeight: 34,
                                    fontWeight: 800,
                                }}
                            >
                                {markButtonTitle}
                            </Button>
                            <Button
                                variant="outlined"
                                size="small"
                                startIcon={<FilterListIcon />}
                                onClick={handleOpenFilterButtonPress}
                                aria-label="openFilterButtonPress"
                            >
                                Filter
                                {hiddenClipCount > 0 &&
                                    ` (${hiddenClipCount})`}
                            </Button>
                            {userCanUsePlaylists && (
                                <Button
                                    variant="outlined"
                                    size="small"
                                    startIcon={<TheatersIcon />}
                                    onClick={
                                        handleCreatePlaylistButtonPress
                                    }
                                    aria-label="createPlaylistButtonPress"
                                >
                                    Create playlist
                                </Button>
                            )}
                            <Tooltip title="More timeline actions">
                                <IconButton
                                    onClick={handleMenuOpen}
                                    aria-label="moreButtonPress"
                                    sx={{
                                        border: "1px solid",
                                        borderColor: "divider",
                                        borderRadius: 2,
                                    }}
                                >
                                    <MoreHorizIcon />
                                </IconButton>
                            </Tooltip>
                        </Box>

                        <Box
                            sx={{
                                display: "grid",
                                gridTemplateColumns: "minmax(0, 1fr)",
                                gap: 2,
                                alignItems: "start",
                            }}
                        >
                            <Paper
                                variant="outlined"
                                sx={{
                                    minWidth: 0,
                                    overflow: "hidden",
                                    borderRadius: 3,
                                    borderColor: "divider",
                                    boxShadow:
                                        "0 6px 24px rgba(20, 35, 25, 0.07)",
                                }}
                            >
                                {file && (
                                    <>
                                        <Box
                                            sx={{
                                                width: "100%",
                                                backgroundColor: "#000",
                                                display: "flex",
                                                justifyContent: "center",
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    position: "relative",
                                                    width: "min(100%, calc((100vh - 235px) * 1.7778))",
                                                    minWidth: 0,
                                                    aspectRatio: "16 / 9",
                                                }}
                                            >
                                                <ReactPlayer
                                                    ref={playerRef}
                                                    url={
                                                        "https://vz-db0e7359-d70.b-cdn.net/" +
                                                        file.key +
                                                        "/playlist.m3u8"
                                                    }
                                                    controls={true}
                                                    playing={playing}
                                                    onPlay={handlePlay}
                                                    onPause={handlePause}
                                                    onEnded={handlePause}
                                                    onProgress={handleProgress}
                                                    width="100%"
                                                    height="100%"
                                                    style={{
                                                        position: "absolute",
                                                        inset: 0,
                                                    }}
                                                />
                                            </Box>
                                        </Box>
                                        <Box
                                            sx={{
                                                p: { xs: 2, sm: 2.5 },
                                                minWidth: 0,
                                            }}
                                        >
                                            <Typography
                                                variant="h5"
                                                component="h1"
                                                sx={{
                                                    fontSize: {
                                                        xs: 21,
                                                        sm: 26,
                                                    },
                                                    lineHeight: 1.25,
                                                    overflowWrap:
                                                        "break-word",
                                                }}
                                            >
                                                {file.displayName}
                                            </Typography>
                                            <Box
                                                sx={{
                                                    mt: 1,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 1,
                                                    flexWrap: "wrap",
                                                }}
                                            >
                                                <Chip
                                                    label={
                                                        timelineName ||
                                                        "Timeline"
                                                    }
                                                    size="small"
                                                    color="primary"
                                                    variant="outlined"
                                                />
                                                <Typography
                                                    variant="caption"
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 0.5,
                                                        color: "text.secondary",
                                                    }}
                                                >
                                                    <SpaceBarOutlinedIcon
                                                        sx={{
                                                            fontSize: 17,
                                                        }}
                                                    />
                                                    Spacebar plays or pauses
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </>
                                )}
                            </Paper>

                            <Paper
                                variant="outlined"
                                sx={{
                                    minWidth: 0,
                                    overflow: "hidden",
                                    borderRadius: 3,
                                    borderColor: "divider",
                                    boxShadow:
                                        "0 3px 14px rgba(20, 35, 25, 0.055)",
                                }}
                            >
                                <Box sx={{ p: 2 }}>
                                    <Box
                                        sx={{
                                            mb: 1.5,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            gap: 1,
                                        }}
                                    >
                                        <Box>
                                            <Typography
                                                variant="h6"
                                                sx={{ lineHeight: 1.2 }}
                                            >
                                                Timeline clips
                                            </Typography>
                                            <Typography
                                                variant="caption"
                                                sx={{
                                                    color: "text.secondary",
                                                }}
                                            >
                                                {visibleRows.length} visible
                                                {hiddenClipCount > 0 &&
                                                    ` · ${hiddenClipCount} filtered`}
                                            </Typography>
                                        </Box>
                                        <Chip
                                            label={
                                                isOwner ? "Owner" : "Shared"
                                            }
                                            size="small"
                                            variant="outlined"
                                        />
                                    </Box>
                                </Box>

                                <Divider />
                                <TableContainer
                                    sx={{
                                        maxHeight: {
                                            xs: 560,
                                            lg: 680,
                                        },
                                        minHeight: 300,
                                        overflow: "auto",
                                    }}
                                >
                                    <Table
                                        stickyHeader
                                        size="small"
                                        aria-label="Timeline clips"
                                        sx={{
                                            minWidth: showDetailsColumn
                                                ? 900
                                                : 760,
                                            "& .MuiTableCell-root": {
                                                px: 1,
                                                py: 0.9,
                                                borderColor: "divider",
                                            },
                                            "& .MuiTableRow-root:hover": {
                                                backgroundColor:
                                                    "rgba(0, 154, 68, 0.045)",
                                            },
                                        }}
                                    >
                                        <TableHead
                                            sx={{
                                                "& .MuiTableCell-root": {
                                                    color: "text.primary",
                                                    backgroundColor:
                                                        "background.subtle",
                                                    fontWeight: 800,
                                                    whiteSpace: "nowrap",
                                                    borderBottom:
                                                        "1px solid rgba(0, 154, 68, 0.2)",
                                                },
                                            }}
                                        >
                                            <TableRow>
                                                <TableCell
                                                    align="center"
                                                    sx={{ width: 48 }}
                                                ></TableCell>
                                                <TableCell
                                                    align="center"
                                                    onClick={
                                                        handleTimeColumnClick
                                                    }
                                                    sx={{ cursor: "pointer" }}
                                                >
                                                    Time
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    onClick={
                                                        handleNameColumnClick
                                                    }
                                                    sx={{ cursor: "pointer" }}
                                                >
                                                    Name
                                                </TableCell>
                                                {showDetailsColumn && (
                                                    <TableCell
                                                        align="center"
                                                        onClick={
                                                            handleDetailsColumnClick
                                                        }
                                                        sx={{
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        Details
                                                    </TableCell>
                                                )}
                                                <TableCell
                                                    align="center"
                                                    onClick={
                                                        handleNoteColumnClick
                                                    }
                                                    sx={{ cursor: "pointer" }}
                                                >
                                                    Note
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    onClick={
                                                        handleStarsColumnClick
                                                    }
                                                    sx={{ cursor: "pointer" }}
                                                >
                                                    Stars
                                                </TableCell>
                                                <TableCell align="center">
                                                    Playlist
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        {visibleRows.length === 0 ? (
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell
                                                        colSpan={
                                                            showDetailsColumn
                                                                ? 7
                                                                : 6
                                                        }
                                                        align="center"
                                                        sx={{
                                                            py: 8,
                                                            color: "text.secondary",
                                                        }}
                                                    >
                                                        {rows.length === 0
                                                            ? "No clips have been added yet."
                                                            : "No clips match the current filters."}
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        ) : (
                                            <TableBody>
                                                {visibleRows.map((row) => (
                                                    <TableRow
                                                        key={row.key}
                                                        sx={{
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        <TableCell
                                                            onClick={handlePreviewRowPressed(
                                                                row
                                                            )}
                                                            component="th"
                                                            scope="row"
                                                            align="center"
                                                        >
                                                            <IconButton
                                                                onClick={handlePreviewRowPressed(
                                                                    row
                                                                )}
                                                                size="small"
                                                                aria-label={`Preview ${row.name}`}
                                                                sx={{
                                                                    color: "primary.main",
                                                                    backgroundColor:
                                                                        "rgba(0, 154, 68, 0.08)",
                                                                    "&:hover": {
                                                                        backgroundColor:
                                                                            "rgba(0, 154, 68, 0.14)",
                                                                    },
                                                                }}
                                                            >
                                                                <PlayArrowIcon fontSize="small" />
                                                            </IconButton>
                                                        </TableCell>

                                                        <TableCell
                                                            onClick={handleRowSelect(
                                                                row
                                                            )}
                                                            component="th"
                                                            scope="row"
                                                            align="center"
                                                            sx={{
                                                                fontWeight: 700,
                                                                whiteSpace:
                                                                    "nowrap",
                                                            }}
                                                        >
                                                            {timeString(
                                                                row.inTime
                                                            )}
                                                        </TableCell>
                                                        <TableCell
                                                            onClick={handleRowSelect(
                                                                row
                                                            )}
                                                            align="center"
                                                        >
                                                            {row.name}
                                                        </TableCell>
                                                        {showDetailsColumn && (
                                                            <TableCell
                                                                onClick={handleRowSelect(
                                                                    row
                                                                )}
                                                                align="center"
                                                            >
                                                                {commaSeperatedStringFromLabels(
                                                                    row.labels
                                                                )}
                                                            </TableCell>
                                                        )}
                                                        <TableCell
                                                            onClick={handleRowSelect(
                                                                row
                                                            )}
                                                            align="center"
                                                        >
                                                            {commaSeperatedStringFromArray(
                                                                row.notes
                                                            )}
                                                        </TableCell>
                                                        <TableCell
                                                            onClick={handleRowSelect(
                                                                row
                                                            )}
                                                            align="center"
                                                        >
                                                            {renderStars(
                                                                row.stars
                                                            )}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <Checkbox
                                                                checked={
                                                                    row.selected
                                                                }
                                                                onChange={handleSelectRowCheckboxChange(
                                                                    row
                                                                )}
                                                                color="primary"
                                                                size="small"
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        )}
                                    </Table>
                                </TableContainer>
                            </Paper>
                        </Box>
                    </Container>
                </Box>
            )}
            <Menu
                id="menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
            >
                <MenuItem onClick={handleShareButtonPressed}>
                    <ListItemIcon>
                        <ShareOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    Share Timeline
                </MenuItem>
                {isOwner ? (
                    <div>
                        <input
                            type="file"
                            id="xml-input"
                            onChange={handleChooseXMLClick}
                            hidden
                        />
                        <label htmlFor="xml-input">
                            <MenuItem htmlFor="xml-input">
                                <ListItemIcon>
                                    <UploadFileOutlinedIcon fontSize="small" />
                                </ListItemIcon>
                                Import XML Timeline
                            </MenuItem>
                        </label>
                    </div>
                ) : (
                    <MenuItem
                        htmlFor="xml-input"
                        onClick={handleChooseXMLClick}
                    >
                        <ListItemIcon>
                            <UploadFileOutlinedIcon fontSize="small" />
                        </ListItemIcon>
                        Import XML Timeline
                    </MenuItem>
                )}

                <MenuItem onClick={handleExportTimelineButtonPress}>
                    <ListItemIcon>
                        <FileDownloadOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    Export XML Timeline
                </MenuItem>
                <MenuItem onClick={handleRenameTimelineButtonPress}>
                    <ListItemIcon>
                        <EditOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    Rename Timeline
                </MenuItem>
                {isOwner && <Divider />}
                {isOwner && (
                    <MenuItem
                        onClick={handleDeleteTimelineButtonPress}
                        sx={{ color: "error.main" }}
                    >
                        <ListItemIcon sx={{ color: "error.main" }}>
                            <DeleteOutlineIcon fontSize="small" />
                        </ListItemIcon>
                        Delete Timeline
                    </MenuItem>
                )}
            </Menu>
            <MarkOutDialog
                open={markOutDialogVisible}
                onClose={handleCloseMarkOutDialog}
                onAdd={handleAddNewRow}
                onEdit={handleEditRow}
                onDelete={handleDeleteRow}
                rowToEdit={rowToEdit}
            />
            {filterDialogVisible && (
                <TimelineFilterDialog
                    open={filterDialogVisible}
                    onClose={handleCloseFilterDialog}
                    rows={rows}
                    ratings={ratings}
                    groupsAfterFiltering={groupsAfterFiltering}
                />
            )}
            <DialogWithTextInput
                open={timelineNameDialogOpen}
                onClose={handleCloseTimelineNameDialog}
                title={"Rename Timeline"}
                message={"Enter a name for the timeline."}
                initialValue={timelineName}
                modern
            />
            <SavePlaylistDialog
                open={playlistNameDialogOpen}
                onClose={handleClosePlaylistNameDialog}
                title={"Save Playlist"}
                message={"Enter a name for the playlist."}
            />
            {confirmDeleteDialogOpen && (
                <ConfirmDeleteDialog
                    title="Delete Timeline"
                    message="Are you sure you want to delete this timeline?"
                    open={confirmDeleteDialogOpen}
                    onClose={handleCloseDeleteDialog}
                />
            )}
            {shareDialogOpen && (
                <ShareTimelineDialog
                    open={shareDialogOpen}
                    onClose={handleCloseShareDialog}
                    timeline={timeline}
                    file={file}
                />
            )}
            {copyDialogOpen && (
                <CopyTimelineDialog
                    open={copyDialogOpen}
                    onClose={handleCloseCopyDialog}
                    title={copyDialogTitle}
                    message={copyDialogMessage}
                />
            )}
            {userHasPermission === false && <NoPermissionsMessage />}
            <div>
                <Snackbar
                    open={statusIsVisible}
                    autoHideDuration={6000}
                    onClose={handleStatusClose}
                >
                    <Alert onClose={handleStatusClose} severity={statusType}>
                        {statusMessage}
                    </Alert>
                </Snackbar>
            </div>
            <ToolbarWithLogo />
            <KeyDownHandler keyWasPressed={keyWasPressed} />
        </>
    );
}
